import { MsalAuthProvider, LoginType } from 'react-aad-msal'
 
// Msal Configurations
const config = {
  auth: {
    authority: 'https://login.microsoftonline.com/f4dbbc31-34c8-4e87-bfe0-b513216204cd',
    clientId: '8739a2c9-15b5-400c-9d51-6224106728ee',
    redirectUri: 'http://localhost:3000/nop/main'
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true
  }
}
 
// Authentication Parameters
const authenticationParameters = {
  scopes: ['user.read']
}
 
// Options
const options = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: `${window.location.origin}/auth.html`
}
 
export const authProvider = new MsalAuthProvider(config, authenticationParameters, options)